// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".small-font[data-v-46298310] {\n  font-size: 18px;\n  font-weight: bold;\n}\n.subtext[data-v-46298310] {\n  font-size: 10px;\n}", ""]);
// Exports
module.exports = exports;
